<template>
    <div class="c-programmes-search" :class="[background]">
        <div class="o-container">
            <div class="o-form -form-preload" :class="{'-loading': loading}">

                <div class="c-loading__inner -search">
                    <div class="c-loading">
                        <svg class="c-loading__svg" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                            <g>
                                <path class="c-loading__letters" d="M50.2,58.4c-0.6,0-1.7,0.1-3.1,0.2c-0.3,0-0.6,0-0.9,0.1l-1.8,7.4h5.9l2-7.9C51.5,58.3,50.8,58.4,50.2,58.4"/>
                                <path class="c-loading__letters" d="M80.7,53.3c-1.2,0.4-2.5,0.8-4,1.2c-0.4,0.1-0.9,0.2-1.3,0.3c-0.2,0-0.3,0.1-0.5,0.1c0,0.2,0,0.4,0,0.6
                                    c0,2.5-1.6,5.1-5.2,5.1c-2.4,0-4.7-1-6.8-3.1l-0.4-0.4l-0.1,0.6L61,62.7L61,62.9l0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.3
                                    c2.5,1.4,5.3,2.1,8.2,2.1c7.2,0,11-5.1,11-10.1C80.9,54.6,80.8,53.9,80.7,53.3"/>
                            </g>
                            <circle class="c-loading__circle" cx="50" cy="50" r="40" stroke="url(#gradient)" stroke-width="5" fill="none" />
                            <defs>
                                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" style="stop-color:#E40032;stop-opacity:1" />
                                <stop offset="100%" style="stop-color:#ffffff;stop-opacity:1" />
                                </linearGradient>
                            </defs>
                            <g>
                                <path class="c-loading__letters" d="M40.8,38.1H23.2l-7.9,31.7h17.8l1.2-4.9H22.4l2.3-9.1h10.1l1.2-4.9H25.9l2-7.9h11.7L40.8,38.1z"/>
                                <path class="c-loading__letters" d="M39.1,30.3c-0.7,0-1.4,0.4-2.7,1.1l-0.1,0.1L30,35.2l-0.9,0.5l1,0.1l1.4,0.1h0.1l0.1,0l7.1-2.2
                                    c0.8-0.2,1.6-0.5,1.9-1.4c0.1-0.4,0-0.8-0.2-1.2c-0.2-0.4-0.5-0.6-0.9-0.8C39.4,30.3,39.2,30.3,39.1,30.3"/>
                                <path class="c-loading__letters" d="M43.3,34.5l-1.2,4.9H51l-0.2,0.8l-4,16.2c0.3,0,0.6,0,0.9-0.1c1-0.1,1.9-0.1,2.3-0.2c0.9-0.1,1.8-0.2,2.8-0.2
                                    l4.1-16.5h8.3l1-4.1l0.2-0.8L43.3,34.5L43.3,34.5z"/>
                                <path class="c-loading__letters" d="M84.5,34.4c-2.9-1.7-5.7-2.1-7.5-2.1c-3,0-5.7,1-7.5,2.9c-1.7,1.7-2.6,4.1-2.6,6.5c0,2.8,1.2,4.8,2.7,6.4
                                    c0.7,0.8,1.5,1.5,2.2,2.1c0.7,0.6,1.3,1.3,1.9,2c0.1,0.2,0.3,0.4,0.4,0.6c0,0,0.1,0,0.1,0c0.6-0.2,1.3-0.3,1.9-0.5
                                    c1.4-0.4,2.7-0.7,3.8-1.1c-0.3-0.6-0.7-1.1-1.1-1.6c-0.6-0.7-1.2-1.3-1.7-1.9l0,0l-0.9-0.9c-0.5-0.4-1-0.9-1.5-1.4
                                    c-1-1.1-1.9-2.4-1.9-3.9c0-2.1,1.6-4.4,4.6-4.4c1.1,0,3.3,0.3,5.6,2.5l0.4,0.4l0.1-0.5l1.1-4.5l0-0.1l0.1-0.2L84.5,34.4L84.5,34.4z
                                    "/>
                            </g>
                        </svg>
                    </div>
                </div>
                <div class="o-form__item__container">
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="programmes-search">{{ t("Mots clés") }}</label>
                        <input @keyup="keyupSearch()" class="o-input" id="programmes-search" type="text" :placeholder="t('Mots clés')" v-model="searchInput">
                        <svg class="o-ico -ico-search" role="img">
                            <title>search</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#search"></use>
                        </svg>
                    </div>
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="niveaux-etudes">{{ t("Niveaux d’études") }}</label>
                        <select @change="changeSelectionCycle()" class="o-select" id="niveaux-etudes" v-model="selectedCycle">
                            <option value="">{{ t("Niveaux d’études") }}</option>
                            <option v-for="cycle in cycles" :value="cycle">{{ cycle }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="type-de-programme">{{ t("Types de programme") }}</label>
                        <select @change="changeSelectionType()" class="o-select" id="type-de-programme" v-model="selectedType">
                            <option value="">{{ t("Types de programme") }}</option>
                            <option v-for="t in types" :value="t.id">{{ t.title }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="departements">{{ t("Départements") }}</label>
                        <select @change="changeSelectionDepartement()" class="o-select" id="departements" v-model="selectedDepartement">
                            <option value="">{{ t("Départements") }}</option>
                            <option v-for="departement in departements" :value="departement.id">{{ formatDepartement(departement.title) }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="Langue-programme">{{ t("Langue") }}</label>
                        <select @change="changeSelectionLangue()" class="o-select" id="Langue-programme" v-model="selectedLangue">
                            <option value="">{{ t("Langue") }}</option>
                            <option v-for="langue in langues" :value="langue">{{ langue }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div v-if="target" class="o-form__button c-tooltip__wrap">
                        <button @click.prevent="refreshUrlQuery()" class="o-button -button-bg" type="submit">
                            <span class="o-button__icos">
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                    </svg>
                                </span>
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                    </svg>
                                </span>
                            </span>
                            <span class="o-button__text">
                                <span class="o-button__text__elm">
                                    {{ t("Rechercher") }} <span class="sr-only">{{ t("une bourse selon les critères sélectionnés") }}</span>
                                </span>
                            </span>
                        </button>

                        <div class="c-tooltip">
                            <span v-if="!target" class="c-tooltip__text">
                                {{ t("Voir les") }} {{ filteredResults.length }} {{ t("résultat") }}{{ filteredResults.length > 1 ? 's' : '' }}
                            </span>
                            <span v-else class="c-tooltip__text">
                                {{ t("Voir les") }} {{ t("résultats") }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="c-programmes-search__filters" :class="{'-loading': loading}">
        <div class="o-container">
            <div class="c-programmes-search__filters__wrap">
                <div v-if="!target" class="c-programmes-search__filters__total">
                    <span>
                        {{ filteredResults.length }} {{ t("résultat") }}{{ filteredResults.length > 1 ? 's' : '' }}
                    </span>
                </div>
                <div v-if="tags.length" class="c-programmes-search__filters__actives">
                    <div v-for="tag in tags" class="c-programmes-search__filters__actives__item">
                        <span>
                            {{ tag.title }}
                        </span>
                        <button @click.prevent="removeTag(tag)" class="c-programmes-search__filters__remove">
                            <span></span>
                            <span></span>
                            <span class="sr-only">{{ t("Retirer le filtre") }} : {{ tag.title }}</span>
                        </button>
                    </div>
                </div>
                <div v-if="!target && (tags.length>0 || searchInput.length>0)" class="c-programmes-search__filters__reset">
                    <button @click.prevent="resetSearch()" class="o-button -button-reset">
                        {{ t("Réinitialiser la recherche") }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div v-if="!target" class="o-section__inner" :class="{'-loading': loading}">
        <div class="o-container">
            <div ref="resultsStart" class="c-projects-search__results">
                <template v-for="entry in filteredResultsPaged">
                    <div class="c-search-results__item -show">
                        <div class="c-search-result__header">
                            <div v-if="entry.credits" class="c-search-result__credits">
                                <span class="c-search-result__credits__item">
                                    {{ entry.credits }}
                                </span>
                            </div>
                            <span class="c-search-result__title o-title-4">
                                <a :href="entry.url" v-html="entry.title"></a>
                            </span>
                        </div>
                        <div class="c-search-result__desc">
                            <p v-html="entry.description"></p>
                        </div>
                        <div v-if="entry.cycle || entry.langue || entry.departements" class="c-search-result__tags">
                            <span v-id="entry.cycle" class="o-tag">
								{{ entry.cycle.replace(/<[^>]*>?/gm, '') }}
                            </span>
                            <span v-for="t in entry.types" class="o-tag">
								{{ getTypeTitle(t).replace(/<[^>]*>?/gm, '') }}
                            </span>
                            <span v-for="departement in entry.departements" class="o-tag">
								{{ formatDepartement(getDepartementTitle(departement)).replace(/<[^>]*>?/gm, '') }}
                            </span>
                            <span v-id="entry.langue" class="o-tag" v-if="entry.langue">
								{{ entry.langue.replace(/<[^>]*>?/gm, '') }}
                            </span>
                        </div>
                </div>
                </template>
            </div>
            <Pager v-if="filteredPageInfo.totalPages>1" :pagerInfo="filteredPageInfo" @goToPage="goToPage" />
        </div>
    </div>
</template>

<script>
    import debounce from 'debounce';
    import Pager from './Pager.vue';

    export default {
        props: {
            background: {
                type: String,
                default: ''
            },
            target: {
                type: String,
                default: false
            },
            query: {
                type: String,
                default: false
            },
            etiquettes: {
                type: String,
                default: ''
            }
        },
        components: {
            Pager
        },
        data() {
            return {
                siteId: 1,
                loading: false,
                searchInput: '',
                searchedIds: null,
                selectedCycle: '',
                selectedDepartement: '',
                selectedLangue: '',
                selectedType: '',
                selectedTypes: [],
                selectedCycles:[],
                selectedDepartements:[],
                selectedLangues:[],
                cycles: [],
                departements: [],
                types: [],
                langues: [],
                results: [],
                controller: null,
                pagerInfo: {
                    currentPage: 1,
                    totalPages: 1
                },
                languageUrl: '/'
            }
        },
        mounted() {
            let lang = document.documentElement.lang;
            if (lang === 'fr-CA') {
                this.siteId = 1;
            } else {
                this.siteId = 2;
                this.languageUrl = '/en/';
            }

            this.fetchAttributes();
        },
        computed: {
            filteredResults() {
                let filtered = this.results;

                if (this.searchedIds!==null) {
                    if (this.searchedIds.length === 0) return [];
                    filtered = filtered.filter(entry => {
                        return this.searchedIds.includes(entry.id);
                    });

                    filtered.sort((a, b) => {
                        return this.searchedIds.indexOf(a.id) - this.searchedIds.indexOf(b.id);
                    });
                }

                if (this.selectedCycles.length) {
                    filtered = filtered.filter(entry => {
                        return this.selectedCycles.some(cycle => entry.cycle == cycle);
                    });
                }
                if (this.selectedDepartements.length) {
                    filtered = filtered.filter(entry => {
                        return this.selectedDepartements.some(departement => entry.departements.includes(departement));
                    });
                }

                if (this.selectedLangues.length) {
                    filtered = filtered.filter(entry => {
                        return this.selectedLangues.some(langue => entry.langue == langue);
                    });
                }

                if (this.selectedTypes.length) {
                    filtered = filtered.filter(entry => {
                        return this.selectedTypes.some(type => entry.types.includes(type));
                    });
                }

                return filtered;
            },
            filteredResultsPaged() {
                return this.filteredResults.slice((this.pagerInfo.currentPage - 1) * 10, this.pagerInfo.currentPage * 10);
            },
            filteredPageInfo() {
                return { totalPages: Math.ceil(this.filteredResults.length / 10), currentPage: this.pagerInfo.currentPage };
            },
            tags() {
                let tags = [];

                this.selectedCycles.forEach(cycle => tags.push({type: 'cycle', title: cycle}));
                this.selectedDepartements.forEach(departement => tags.push({type: 'departement', title: this.getDepartementTitle(departement)}));
                this.selectedTypes.forEach(type => tags.push({type: 'type', title: this.getTypeTitle(type)}));
                this.selectedLangues.forEach(langue => tags.push({type: 'langue', title: langue}));
                //this.selectedTypes.forEach(type => tags.push({type: 'type', title: type}));
                return tags
            }
        },
        methods: {
            formatDepartement(title) {
                // remove Département de from title
                title = title.replace('Département de ', '');
                title = title.replace('Département des ', '');
                return title.charAt(0).toUpperCase() + title.slice(1);
            },
            t(string) {
                return ProgrammeLocalisation[string];
            },
            getDepartementTitle(id) {
                if (this.departements === undefined ) return;
                let departement = this.departements.find(departement => departement.id === id);
                return departement.title;
            },
            getTypeTitle(id) {
                if (this.types === undefined ) return;
                let type = this.types.find(type => type.id === id);
                if (type === undefined) {
                    type = this.types.find(type => type.title.includes(id));
                }
                if (type === undefined) return;
                return type.title;
            },
            fetchAttributes() {
                this.loading = true;
                fetch(this.languageUrl + 'api/search/programme-index?siteId=' + this.siteId + '&etiquettes=' + this.etiquettes, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.departements !== undefined) this.departements = data.departements;
                    if (data.cycles !== undefined) this.cycles = data.cycles;
                    if (data.langues !== undefined) this.langues = data.langues;
                    if (data.types !== undefined) this.types = data.types;
                    if (!this.target && data.results !== undefined) this.results = data.results;

                    this.pagerInfo.totalPages = Math.ceil(this.results.length / 10);
                    this.loading = false;

                    const currentUrl = new URL(window.location.href);
                    let query = currentUrl.search;
                    if (this.query.length) {
                        // add ? if not present
                        if (this.query[0] !== '?') {
                            query = '?' + this.query;
                        } else {
                            query = this.query;
                        }
                        this.query = '';
                    }
                    const urlParams = new URLSearchParams(query);
                    let doSearch = false
                    if (urlParams.has('cycles')) {
                        this.selectedCycles = urlParams.get('cycles').split(',');
                    }
                    if (urlParams.has('departements')) {
                        let split = urlParams.get('departements').split(',');
                        this.selectedDepartements = split.map(Number);
                    }
                    if (urlParams.has('types')) {
                        let split = urlParams.get('types').split(',');
                        this.selectedTypes = split.map(Number);

                        // if split is an array of 1 and the value is not a number, it means it's a string
                        if (split.length === 1 && isNaN(split[0])) {
                            split = split[0]
                            if (split == 'Maîtrises') {
                                this.selectedTypes = [697435, 697451];
                            } else {
                                //console.log(split);
                                // loop through types to find the id if type.title contains the value
                                this.selectedTypes = this.types.filter(type => split[0].includes(type.title)).map(type => type.id);
                            }
                        }
                    }
                    if (urlParams.has('langues')) {
                        this.selectedLangues = urlParams.get('langues').split(',');
                    }
                    if (urlParams.has('s')) {
                        this.searchInput = urlParams.get('s');
                        doSearch = true;
                    }
                    if (doSearch) {
                        this.search();
                    }
                })
            },
            goToPage(page) {
                this.$refs.resultsStart.scrollIntoView({ behavior: 'smooth' });
                setTimeout(() => {
                    this.pagerInfo.currentPage = page;
                }, 100);
            },
            changeSelectionCycle() {
                let current = this.selectedCycle;
                if (current === '') return;
                if (!this.selectedCycles.includes(current)) {
                    this.selectedCycles.push(current);
                    if (!this.target) this.refreshUrlQuery();
                }
                this.selectedCycle = '';
            },
            changeSelectionLangue() {
                let current = this.selectedLangue;
                if (current === '') return;
                if (!this.selectedLangues.includes(current)) {
                    this.selectedLangues.push(current);
                    if (!this.target) this.refreshUrlQuery();
                }
                this.selectedLangue = '';
            },
            changeSelectionType() {
                let current = this.selectedType;
                if (current === '') return;
                if (!this.selectedTypes.includes(current)) {
                    this.selectedTypes.push(current);
                    if (!this.target) this.refreshUrlQuery();
                }
                this.selectedType = '';
            },
            changeSelectionDepartement() {
                let current = this.selectedDepartement;
                if (current === '') return;
                if (!this.selectedDepartements.includes(current)) {
                    this.selectedDepartements.push(current);
                    if (!this.target) this.refreshUrlQuery();
                }
                this.selectedDepartement = '';
            },
            removeTag(tag) {
                if (tag.type === 'cycle') {
                    this.selectedCycles = this.selectedCycles.filter(cycle => cycle !== tag.title);
                } else if (tag.type === 'type') {
                    this.selectedTypes = this.selectedTypes.filter(type => this.getTypeTitle(type) !== tag.title);
                } else if (tag.type === 'departement') {
                    this.selectedDepartements = this.selectedDepartements.filter(departement => this.getDepartementTitle(departement) !== tag.title);
                } else {
                    this.selectedLangues = this.selectedLangues.filter(langue => langue !== tag.title);
                }
                if (this.target) return;
                this.refreshUrlQuery();
            },
            keyupSearch: debounce(function(e) {
                if (this.controller) this.controller.abort();
                if (this.searchInput.length >= 3) {
                    if (this.target) return;
                    this.refreshUrlQuery();
                    this.search();
                } else {
                    this.searchedIds = null;
                    this.refreshUrlQuery();
                }
            }, 500),
            search() {
                this.refreshUrlQuery();
                if (this.target) return;
                this.loading = true;
                if (this.controller) {
                    this.controller.abort();
                }

                this.controller = new AbortController();

                fetch(this.languageUrl + 'api/search/programme?s='+this.searchInput+'&siteId=' + this.siteId, {
                    signal: this.controller.signal,
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error !== undefined) {
                            this.searchedIds = [];
                            this.loading = false;
                            return;
                        }
                        this.searchedIds = data;
                        this.loading = false;
                    })
                    .catch(err => {
                        this.searchedIds = null;
                        this.searchInput = '';
                        this.loading = false;
                    });
            },
            resetSearch() {
                this.searchInput = '';
                this.searchedIds = null;
                this.selectedCycles = [];
                this.selectedLangues = [];
                this.selectedDepartements = [];
                this.selectedTypes = [];
                this.refreshUrlQuery();
                this.pagerInfo.currentPage = 1;
            },
             refreshUrlQuery() {
                let query = '';
                if (this.selectedCycles.length > 0) {
                    query += 'cycles=' + this.selectedCycles.join(',') + '&';
                }
                if (this.selectedTypes.length > 0) {
                    query += 'types=' + this.selectedTypes.join(',') + '&';
                }
                if (this.selectedDepartements.length > 0) {
                    query += 'departements=' + this.selectedDepartements.join(',') + '&';
                }
                if (this.selectedLangues.length > 0) {
                    query += 'langues=' + this.selectedLangues.join(',') + '&';
                }
                if (this.searchInput) {
                    query += 's=' + this.searchInput;
                }
                const currentUrl = new URL(window.location.href);
                let pathName = currentUrl.pathname;
                pathName = pathName.replace(/(p\d)/, '');
                let newUrl = currentUrl.origin + pathName + '?' + query;
                if (this.target) {
                    newUrl = this.target + '?' + query;
                    window.location.href = newUrl;
                }
                window.history.pushState({path:newUrl},'',newUrl);
                try {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'search_programme',
                        'page_category': 'Programmes',
                        'departement': this.selectedDepartements.length ? this.selectedDepartements.join(',') : 'Aucun',
                        'cycle': this.selectedCycles.length ? this.selectedCycles.join(',') : 'Aucun',
                        'type': this.selectedTypes.length ? this.selectedTypes.join(',') : 'Aucun',
                        'langue': this.selectedLangues.length ? this.selectedLangues.join(',') : 'Aucun',
                        'recherche': this.searchInput
                    })
                }
                catch(e) {}
                this.pagerInfo.currentPage = 1;
            },
        },
    }
</script>